// Enables critical path CSS rendering on the server
// https://github.com/kriasoft/isomorphic-style-loader
export const cssRegistry = new Set<string>();

export const registerStyles = (...styles: IsomorphicStyleModule[]) => {
  styles.forEach(({ _getCss }) => cssRegistry.add(_getCss()));
};

export const cleanupStyles = (...styles: IsomorphicStyleModule[]) => {
  const removeCss = styles.map(({ _insertCss }) => _insertCss());

  return () => removeCss.forEach(dispose => dispose());
};
